import axios from "axios";

export const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("eid_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && localStorage.getItem("eid_token")) {
      original._retry = true;
      try {
        refreshing = refreshing || API.post("/auth/refresh").then(({ data }) => {
          localStorage.setItem("eid_token", data.access_token);
          refreshing = null;
          return data.access_token;
        });
        const token = await refreshing;
        original.headers.Authorization = `Bearer ${token}`;
        return API(original);
      } catch (e) {
        localStorage.removeItem("eid_token");
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}
